import logo from "../assets/images/logo.svg";
import circle from "../assets/images/circle.svg";
import bgWhite from "../assets/images/bgWhite.png";
import hero from "../assets/images/photo.jpg";

export default { logo, circle, bgWhite, hero };
